import type {AppPayload} from '@github-ui/issues-shared/app-payload'
/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload -- Cannot use UI Service because we're within Relay environment */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import {useParams} from '@github-ui/react-router'
import {ReposIssuesSidebar as SharedRepoIssuesSidebar} from '@github-ui/repos-issues-sidebar-ui/ReposIssuesSidebar'

import {usePreloadSidebarPages} from '../../hooks/use-preload-sidebar-pages'
import {RepoSavedViewsNav} from './RepoSavedViewsNav'

export function RepoIssuesSidebar({collapsible}: {collapsible?: boolean} = {}) {
  usePreloadSidebarPages()
  const {owner, repo} = useParams<{owner: string; repo: string}>()
  const {scoped_repository} = useAppPayload<AppPayload>()
  const hasProjectsEnabled = scoped_repository?.has_projects_enabled ?? false
  return (
    <SharedRepoIssuesSidebar
      owner={owner ?? ''}
      repo={repo ?? ''}
      collapsible={collapsible}
      hasProjectsEnabled={hasProjectsEnabled}
      renderSavedViewsNav={ctx => <RepoSavedViewsNav owner={owner ?? ''} repo={repo ?? ''} {...ctx} />}
    />
  )
}
